import { RolePageData } from '../types'
import { hrData } from './hrData'
import { marketingData } from './marketingData'
import { operationsData } from './operationsData'
import { eventsData } from './eventsData'
import { founderData } from './founderData'

export const ALL_ROLE_DATA: Record<string, RolePageData> = {
  hr: hrData,
  marketing: marketingData,
  operations: operationsData,
  events: eventsData,
  founders: founderData,
}

export const getRoleDataBySlug = (slug: string): RolePageData | undefined => {
  return ALL_ROLE_DATA[slug]
}

export { hrData, marketingData, operationsData, eventsData, founderData }
